import { ERROR_TYPES } from './constant';

class GlobalErrorHandler {
  constructor(options = {}) {
    this.options = {
      maxListeners: options.maxListeners || 10,
    };
    this.id = 0;
    this.listeners = new Set();
    this._initNativeListeners();
  }

  // 初始化原生事件监听
  _initNativeListeners() {
    this._addNativeListener('error');
    this._addNativeListener('unhandledrejection');
  }

  // 添加原生事件监听器
  _addNativeListener(eventType) {
    const listener = (event) => {
      console.log('[_addNativeListener] 捕获到原生错误事件:', event, event.error);
      const errorInfo = this._parseNativeEvent(event);
      if (errorInfo) { this._triggerListeners(errorInfo); }
    };
    window.addEventListener(eventType, listener, true);
    return { type: eventType, listener };
  }

  // 添加错误监听器
  addListener = (callback) => {
    try {
    if (this.listeners.size >= this.options.maxListeners) {
      console.log('[ErrorHandler] 超过最大监听器数量限制');
      return null;
    }
    const id = ++this.id;
    this.listeners.add({ id, callback });
    return id;
    } catch (e) {
      console.log('[ErrorHandler] 添加监听器失败:', e);
      return null;
    }
  }

  // 移除错误监听器
  removeListener = (id) => {
    this.listeners = new Set([...this.listeners].filter(listener => listener.id !== id));
  }

  // 触发所有监听器
  _triggerListeners(error) {
    console.log(this.listeners, '>>>>>>this.listeners');
    this.listeners.forEach(({ callback }) => {
      try {
        callback(error);
      } catch (e) {
        console.error('[ErrorHandler] 监听器执行失败:', e);
      }
    });
  }

  // 解析原生错误事件
  _parseNativeEvent(event) {
    console.log('[ErrorHandler] 捕获到原生错误事件:', event.error);
    if (event instanceof ErrorEvent) {
      return {
        type: ERROR_TYPES.JAVASCRIPT,
        message: event.message,
        stack: event.error?.stack || '',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        category: this._getErrorCategory(event),
      };
    }

    if (event instanceof PromiseRejectionEvent) {
      const error = event.reason instanceof Error ? event.reason : new Error(event.reason);
      return {
        type: ERROR_TYPES.PROMISE,
        message: error.message,
        stack: error?.stack || '',
        filename: event?.filename,
        lineno: event?.lineno,
        colno: event?.colno,
        category: this._getErrorCategory(event),
      };
    }

    const resourceParseInfo = this._handleResourceError(event);
    if (resourceParseInfo) {
      return resourceParseInfo;
    }

    return null;
  }

  // 错误分类逻辑
  _getErrorCategory(error) {
    if (error instanceof Error) {
      if (error.message.includes('NetworkError')) { return 'NETWORK'; }
      if (error.message.includes('Timeout')) { return 'TIMEOUT'; }
      if (error.stack?.includes('webpack')) { return 'WEBPACK_BUILD'; }
      return 'APPLICATION';
    }
    return 'GENERAL';
  }

  // 资源加载错误处理
  _handleResourceError(event) {
    if (event?.target?.tagName === 'IMG') {
      return {
        type: ERROR_TYPES.RESOURCE,
        subType: 'IMAGE_LOAD_FAILED',
        url: event.target.src || event.target.href,
        status: event.target.error?.status || 'LOAD_FAILED',
        message: `Image load failed: ${event.target.src}`,
        category: 'RESOURCE_LOAD',
      };
    } else if (event?.target?.tagName === 'SCRIPT') {
      return {
        type: ERROR_TYPES.RESOURCE,
        subType: 'SCRIPT_LOAD_FAILED',
        url: event.target.src,
        message: `Script load failed: ${event.target.src}`,
        status: 'SCRIPT_LOAD_FAILED',
        category: 'RESOURCE_LOAD',
      };
    }
  }

  // 销毁实例
  destroy = () => {
    this.listeners.clear();
    this._removeAllNativeListeners();
  }

  // 移除所有原生监听器
  _removeAllNativeListeners() {
    window.removeEventListener('error', this._errorListener);
    window.removeEventListener('unhandledrejection', this._promiseListener);
  }
}

// 创建默认实例
const defaultInstance = new GlobalErrorHandler();

export const {
  addListener,
  removeListener,
  destroy,
} = defaultInstance;
